import React, { useState, useRef, useEffect } from "react";
import { NavLink } from "react-router-dom";
import {
  FaUsers,
  FaCalendarAlt,
  FaEnvelope,
  FaMoneyBillWave,
  FaUserCheck,
  FaChartBar,
  FaAddressCard,
  FaCartPlus,
  FaRegCreditCard,
  FaUserCircle,
  FaFileSignature,
  FaRegNewspaper,
  FaImage,
  FaComment,
  FaHourglassHalf,
  FaCalculator,
  FaShoppingBag,
  FaReact,
  FaCommentMedical,
  FaVoteYea,
  FaDumbbell,
  FaBalanceScale,
  FaBullseye,
} from "react-icons/fa";
import { IoMdContacts, IoMdSettings } from "react-icons/io";
import {
  GiBlackBelt,
  GiKimono,
  GiPodiumWinner,
  GiPodium,
  GiGong,
} from "react-icons/gi";
import { MdDashboard, MdTimer, MdOutlineInventory } from "react-icons/md";
import { MdScoreboard, MdBrowserUpdated } from "react-icons/md";
import { PiTranslateFill } from "react-icons/pi";
import { LuListTodo } from "react-icons/lu";
import { BsClipboardCheckFill } from "react-icons/bs";
import { RiQuestionnaireFill } from "react-icons/ri";
import { GrArticle } from "react-icons/gr";
import { FaHandshake, FaBarsProgress } from "react-icons/fa6";
import { AiFillHeart, AiOutlineHeart } from "react-icons/ai";

// Association mise à jour des titres de liens et des icônes
const linkIcon = {
  "Tableau de Bord": <MdDashboard />,
  "Dossier d'Inscription": <FaAddressCard />,
  "Fiche Adhérent": <FaUserCircle />,
  Absences: <FaCommentMedical />,
  Calendrier: <FaCalendarAlt />,
  Messages: <FaEnvelope />,
  Chat: <FaComment />,
  Boutique: <FaCartPlus />,
  "Commandes & Règlements": <FaRegCreditCard />,
  "Prépa Physique": <FaDumbbell />,
  "Techniques Judo": <GiKimono />,
  "Techniques Quizz": <GiKimono />,
  "Vote Sondage Utilisateur": <FaVoteYea />,
  Actualités: <FaRegNewspaper />,
  Lexique: <PiTranslateFill />,
  "Arbitrage Judo": <GiGong />,
  "Applications Judo": <FaReact />,
  "Galerie Photos": <FaImage />,
  "Cours Agenda": <FaCalendarAlt />,
  "Listing Adhérents": <IoMdContacts />,
  "Passage Ceinture": <GiBlackBelt />,
  "Grade CN": <GiBlackBelt />,
  "Prépa Physique Coaching": <FaDumbbell />,
  "Suivi Compétitions": <GiPodiumWinner />,
  Palmarès: <GiPodium />,
  "Objectifs": <FaBullseye />,
  ToDoList: <LuListTodo />,
  "Techniques Enseignants": <GiKimono />,
  Catégories: <FaBalanceScale />,
  Événements: <FaCalendarAlt />,
  "Appel Présence": <FaUserCheck />,
  "Tableau Appel": <BsClipboardCheckFill />,
  "Aide Enseignants": <RiQuestionnaireFill />,
  "Dashboard Adhérents": <FaChartBar />,
  "Dashboard Comptabilité": <FaChartBar />,
  "Détails Adhérent": <FaUserCircle />,
  "Listing Utilisateurs": <FaUsers />,
  "Listing Adhérents Admin": <FaUsers />,
  "Règlements Inscriptions": <FaMoneyBillWave />,
  "Dossiers d'Inscription": <FaFileSignature />,
  Paiements: <FaCartPlus />,
  "Articles Admin": <FaShoppingBag />,
  "Dépenses Recettes": <FaCalculator />,
  Coachings: <MdTimer />,
  "Heures Enseignement": <FaHourglassHalf />,
  Inventaire: <MdOutlineInventory />,
  "Prêt Matériel": <GiKimono />,
  "Chat Page Admin": <FaComment />,
  "Message Admin": <FaEnvelope />,
  "Vote Sondage Admin": <FaVoteYea />,
  "Pages Personnalisées": <GrArticle />,
  Paramètres: <IoMdSettings />,
  "Requêtes Admin": <RiQuestionnaireFill />,
  Abonnement: <FaRegCreditCard />,
  Update: <MdBrowserUpdated />,
  "Aide Conseils": <RiQuestionnaireFill />,
};

const sections = {
  2: {
    label: "Utilisateur",
    links: [
      "Tableau de Bord",
      "Dossier d'Inscription",
      "Fiche Adhérent",
      "Absences",
      "Calendrier",
      "Messages",
      "Chat",
      "Boutique",
      "Commandes & Règlements",
      "Prépa Physique",
      "Actualités",
      "Galerie Photos",
      "Lexique",
      "Arbitrage Judo",
      "Applications Judo",
      "Techniques Judo",
      "Techniques Quizz",
      "Vote Sondage Utilisateur",
    ],
  },
  3: {
    label: "Enseignant",
    links: [
      "Listing Adhérents",
      "Appel Présence",
      "Tableau Appel",
      "Cours Agenda",
      "Passage Ceinture",
      "Grade CN",
      "Événements",
      "Prépa Physique Coaching",
      "Suivi Compétitions",
      "Palmarès",
      "Objectifs",
      "ToDoList",
      "Techniques Enseignants",
      "Catégories",
      "Aide Enseignants",
    ],
  },
  1: {
    label: "Administrateur",
    links: [
      "Dashboard Adhérents",
      "Dashboard Comptabilité",
      "Détails Adhérent",
      "Listing Utilisateurs",
      "Listing Adhérents Admin",
      "Règlements Inscriptions",
      "Dossiers d'Inscription",
      "Paiements",
      "Articles Admin",
      "Cours Agenda",
      "Dépenses Recettes",
      "Coachings",
      "Heures Enseignement",
      "Inventaire",
      "Prêt Matériel",
      "Chat Page Admin",
      "Message Admin",
      "Vote Sondage Admin",
      "Pages Personnalisées",
      "Paramètres",
      "Requêtes Admin",
      "Abonnement",
      "Update",
      "Aide Conseils",
    ],
  },
};

const DISPLAY_BY_LABEL = {
  // Utilisateur
  Absences: "display_absences",
  Calendrier: "display_calendrier",
  Chat: "display_chat",
  Boutique: "display_boutique",
  "Commandes & Règlements": "display_commandes",
  "Prépa Physique": "display_prepa_physique",
  Actualités: "display_news",
  "Galerie Photos": "display_galerie",
  Lexique: "display_lexique",
  "Arbitrage Judo": "display_arbitrage",
  "Applications Judo": "display_applications",
  "Techniques Judo": "display_techniques",
  "Techniques Quizz": "display_techniquesquizz",
  "Vote Sondage Utilisateur": "display_vote",

  // Enseignant
  "Appel Présence": "display_appels",
  "Tableau Appel": "display_tableauappel",
  "Passage Ceinture": "display_passage",
  "Grade CN": "display_gradecn",
  Événements: "display_evenements",
  "Prépa Physique Coaching": "display_prepa_physique_coaching",
  "Suivi Compétitions": "display_suivicompetition",
  Palmarès: "display_palmares",
  "Objectifs": "display_objectifs",
  ToDoList: "display_todolist",
  "Techniques Enseignants": "display_techniquesenseignants",
  Catégories: "display_categories",

  // Admin
  "Articles Admin": "display_articlesadmin",
  "Dépenses Recettes": "display_depensesrecettes",
  Coachings: "display_coaching",
  "Heures Enseignement": "display_heures_enseignants",
  Inventaire: "display_inventaire",
  "Prêt Matériel": "display_pretmateriel",
  "Chat Page Admin": "display_chat_admin",
  "Message Admin": "display_messages_admin",
  "Vote Sondage Admin": "display_voteadmin",
  "Pages Personnalisées": "display_pagespersonnalisees",
};

const coerceBool = (val, fallback = true) => {
  if (val === undefined || val === null) return fallback; // si pas de clé : visible
  if (typeof val === "boolean") return val;
  if (typeof val === "number") return val !== 0;
  if (typeof val === "string") {
    const v = val.trim().toLowerCase();
    if (["true", "1", "yes", "on"].includes(v)) return true;
    if (["false", "0", "no", "off"].includes(v)) return false;
  }
  return !!val;
};

// Remplace UNIQUEMENT le composant MegaMenu par ce bloc.
// Ajouts :
// - Swipe gauche/droite (mobile & desktop tactile) pour changer d’onglet
// - Indicateur en bas quand il reste du contenu à faire défiler (gradient + message)
// - Pas de flèches visibles

// --- Composant ---
const MegaMenu = ({ role_id, settings, closeMegaMenu, onClose }) => {
  const handleClose = onClose || closeMegaMenu || (() => {});
  const lastActiveTab =
    parseInt(localStorage.getItem("lastActiveTab"), 10) || 0;

  const [activeTab, setActiveTab] = useState(lastActiveTab);
  const [query, setQuery] = useState("");
  const [hasMoreBelow, setHasMoreBelow] = useState(false);

  // Favoris (localStorage par rôle, max 5) + vue favoris
  const FAV_KEY = `megamenu_favorites_${role_id || "guest"}`;
  const FAV_VIEW_KEY = "megamenu_showFavs";
  const [favorites, setFavorites] = useState(() => {
    try {
      const raw = localStorage.getItem(FAV_KEY);
      return Array.isArray(JSON.parse(raw)) ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });
  const [showFavsOnly, setShowFavsOnly] = useState(() => {
    try {
      return localStorage.getItem(FAV_VIEW_KEY) === "1";
    } catch {
      return false;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem(FAV_KEY, JSON.stringify(favorites.slice(0, 5)));
    } catch {}
  }, [favorites, FAV_KEY]);

  useEffect(() => {
    try {
      localStorage.setItem(FAV_VIEW_KEY, showFavsOnly ? "1" : "0");
    } catch {}
  }, [showFavsOnly]);

  // swipe
  const [touchStart, setTouchStart] = useState(null);
  const [touchPos, setTouchPos] = useState(null);

  const orderedSections =
    role_id === 1 || role_id === 4
      ? [sections[2], sections[3], sections[1]]
      : role_id === 3
      ? [sections[2], sections[3]]
      : [sections[2]];

  const currentSection =
    orderedSections[activeTab] || orderedSections[0] || sections[2];

  // Toutes les tuiles disponibles (pour filtrer les favoris à travers les onglets)
  const allLinks = React.useMemo(
    () => Array.from(new Set(orderedSections.flatMap((s) => s.links))),
    [orderedSections]
  );

  // helpers favoris
  const isFav = (label) => favorites.includes(label);
  const toggleFav = (label) => {
    setFavorites((prev) => {
      if (prev.includes(label)) return prev.filter((l) => l !== label);
      if (prev.length >= 5) {
        window?.alert?.("Vous pouvez enregistrer jusqu'à 5 favoris.");
        return prev;
      }
      return [...prev, label];
    });
  };

  // Filtre texte + favoris
  let baseLinks;
  if (showFavsOnly) {
    const source = favorites.length ? favorites : [];
    baseLinks = source.filter((l) =>
      !query ? true : l.toLowerCase().includes(query.toLowerCase())
    );
  } else {
    const source = currentSection.links;
    baseLinks = !query
      ? source
      : source.filter((l) => l.toLowerCase().includes(query.toLowerCase()));
  }

  // Filtre display_* : n’afficher que si la clé liée est true ; si pas de clé => afficher
  const visibleLinks = baseLinks
    .filter((label) => {
      // si on est en favoris, éliminer les liens absents de l’ensemble autorisé
      if (showFavsOnly && !allLinks.includes(label)) return false;
      const key = DISPLAY_BY_LABEL[label];
      if (!key) return true;
      return coerceBool(settings?.[key], true);
    })
    .slice(0, showFavsOnly ? 5 : undefined);

  useEffect(() => {
    localStorage.setItem("lastActiveTab", activeTab);
  }, [activeTab]);

  // swipe handlers
  const startSwipe = (x, y) => setTouchStart({ x, y, t: Date.now() });
  const moveSwipe = (x, y) => setTouchPos({ x, y });
  const endSwipe = () => {
    if (!touchStart || !touchPos) {
      setTouchStart(null);
      setTouchPos(null);
      return;
    }
    const dx = touchPos.x - touchStart.x;
    const dy = touchPos.y - touchStart.y;
    if (!showFavsOnly && Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) {
      if (dx < 0 && activeTab < orderedSections.length - 1)
        setActiveTab((v) => v + 1);
      else if (dx > 0 && activeTab > 0) setActiveTab((v) => v - 1);
    }
    setTouchStart(null);
    setTouchPos(null);
  };

  // Indicateur "reste du contenu"
  const scrollRef = useRef(null);
  const recomputeHasMore = () => {
    const el = scrollRef.current;
    if (!el) return;
    setHasMoreBelow(el.scrollTop + el.clientHeight < el.scrollHeight - 1);
  };
  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    recomputeHasMore();
    const onScroll = () => recomputeHasMore();
    el.addEventListener("scroll", onScroll);
    return () => el.removeEventListener("scroll", onScroll);
  }, [visibleLinks.length, showFavsOnly]);

  return (
    <div
      role="dialog"
      aria-modal="true"
      className="relative mx-auto max-w-[1280px] rounded-2xl bg-white/95 dark:bg-slate-800/95 backdrop-blur shadow-2xl overflow-hidden"
      onTouchStart={(e) =>
        startSwipe(e.touches[0].clientX, e.touches[0].clientY)
      }
      onTouchMove={(e) => moveSwipe(e.touches[0].clientX, e.touches[0].clientY)}
      onTouchEnd={endSwipe}
      onPointerDown={(e) => {
        if (e.pointerType !== "mouse") startSwipe(e.clientX, e.clientY);
      }}
      onPointerMove={(e) => {
        if (e.pointerType !== "mouse" && touchStart)
          moveSwipe(e.clientX, e.clientY);
      }}
      onPointerUp={(e) => {
        if (e.pointerType !== "mouse") endSwipe();
      }}
    >
      {/* Header */}
      <div className="sticky top-0 z-10 bg-slate-900 text-white border-b border-slate-800">
        <div className="px-4 md:px-6 py-3">
          <div className="flex flex-wrap items-center gap-2">
            {/* Onglets */}
            <div className="order-1 flex flex-wrap items-center gap-2">
              {orderedSections.map((section, idx) => (
                <button
                  key={idx}
                  onClick={() => setActiveTab(idx)}
                  type="button"
                  className={`px-3 md:px-4 py-1.5 text-sm font-semibold rounded-full transition-colors ${
                    activeTab === idx && !showFavsOnly
                      ? "bg-primary text-white"
                      : "bg-slate-800 text-slate-200 hover:bg-slate-700"
                  } ${showFavsOnly ? "opacity-50 pointer-events-none" : ""}`}
                >
                  {section.label}
                </button>
              ))}
            </div>

            {/* Fermer */}
            <button
              onClick={handleClose}
              type="button"
              aria-label="Fermer le menu"
              className="order-2 ml-auto md:ml-0 md:order-4 inline-flex items-center justify-center w-10 h-10 rounded-full bg-primary text-white shadow-md transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50"
            >
              x
            </button>

            {/* Recherche */}
            <div className="order-3 md:order-2 md:ml-auto w-full md:w-[min(520px,65%)]">
              <div className="flex items-center gap-2">
                <input
                  type="text"
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  placeholder={
                    showFavsOnly
                      ? "Rechercher dans vos favoris…"
                      : "Rechercher une fonctionnalité…"
                  }
                  className="flex-1 px-3 py-2 rounded-xl border border-slate-700 bg-slate-800 text-white placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-primary/50"
                />

                {/* Toggle Favoris */}
                <button
                  type="button"
                  onClick={() => setShowFavsOnly((v) => !v)}
                  title={
                    showFavsOnly
                      ? "Afficher tout le menu"
                      : "N’afficher que mes favoris"
                  }
                  className={`inline-flex items-center justify-center w-10 h-10 rounded-full shadow-md transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50 ${
                    showFavsOnly
                      ? "bg-rose-600 text-white"
                      : "bg-slate-800 text-rose-500 hover:bg-slate-700"
                  }`}
                >
                  {showFavsOnly ? (
                    <AiFillHeart className="text-xl" />
                  ) : (
                    <AiOutlineHeart className="text-xl" />
                  )}
                </button>

                {/* Compteur favoris */}
                <span className="hidden md:inline-block text-xs px-2 py-1 rounded-full bg-slate-800 text-slate-200 ring-1 ring-slate-700">
                  {favorites.length}/5
                </span>

                {/* Bouton Paramètres (admin) */}
                {role_id === 1 && (
                  <NavLink
                    to="/parametres"
                    onClick={handleClose}
                    aria-label="Ouvrir les paramètres"
                    className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-primary text-white shadow-md transition-colors hover:bg-primary/90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50"
                  >
                    <IoMdSettings className="text-xl" />
                  </NavLink>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contenu */}
      <div
        ref={scrollRef}
        className="relative px-4 md:px-6 py-4 max-h-[70vh] overflow-y-auto overflow-x-hidden"
      >
        {visibleLinks.length > 0 ? (
          <ul
            className="grid gap-3 md:gap-4"
            style={{
              gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
            }}
          >
            {visibleLinks.map((link, linkIdx) => (
              <li key={linkIdx} className="min-w-0">
                <NavLink
                  to={`/${link
                    .toLowerCase()
                    .replace(/[\s'ç]/g, "-")
                    .normalize("NFD")
                    .replace(/[\u0300-\u036f]/g, "")}`}
                  onClick={handleClose}
                  className="group relative block w-full max-w-full min-w-0 p-3 rounded-xl bg-white dark:bg-slate-800 ring-1 ring-slate-200 dark:ring-slate-700 shadow-sm hover:shadow-xl transition-all duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50"
                >
                  {/* Barre colorée au hover */}
                  <span className="pointer-events-none absolute left-0 top-0 bottom-0 w-[6px] bg-orange-600 dark:bg-orange-400 opacity-0 group-hover:opacity-100 transition-opacity rounded-l-xl" />

                  {/* Bouton favori sur la carte */}
                  <button
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      toggleFav(link);
                    }}
                    title={
                      isFav(link)
                        ? "Retirer des favoris"
                        : "Ajouter aux favoris"
                    }
                    className="absolute top-2 right-2 inline-flex items-center justify-center w-8 h-8 rounded-full bg-white/90 dark:bg-slate-700/90 text-rose-500 shadow ring-1 ring-slate-200 dark:ring-slate-600 hover:scale-105"
                  >
                    {isFav(link) ? <AiFillHeart /> : <AiOutlineHeart />}
                  </button>

                  <div className="flex flex-col items-center text-center">
                    <div className="mb-2 inline-flex h-14 w-14 items-center justify-center rounded-xl text-orange-600 text-3xl transition-transform group-hover:scale-110">
                      {linkIcon[link]}
                    </div>
                    <span className="text-[13px] leading-tight font-semibold text-slate-800 dark:text-slate-100 break-words">
                      {link}
                    </span>
                  </div>
                </NavLink>
              </li>
            ))}
          </ul>
        ) : (
          <div className="text-center text-sm text-slate-500 dark:text-slate-300 py-10">
            {showFavsOnly
              ? "Vous n’avez pas encore de favoris."
              : `Aucune entrée ne correspond à “${query}”.`}
          </div>
        )}

        {hasMoreBelow && !showFavsOnly && (
          <>
            <div className="pointer-events-none absolute bottom-0 left-0 right-0 h-10 bg-gradient-to-t from-white dark:from-slate-800 to-transparent" />
            <div className="pointer-events-none absolute bottom-2 left-1/2 -translate-x-1/2">
              <span className="text-[11px] px-2 py-1 rounded-full bg-white/90 dark:bg-slate-800/90 text-slate-600 dark:text-slate-200 shadow">
                Faites défiler pour voir plus
              </span>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default MegaMenu;
